import { render, staticRenderFns } from "./ProductsDetail.vue?vue&type=template&id=2a8914d5&scoped=true"
import script from "./ProductsDetail.vue?vue&type=script&lang=js"
export * from "./ProductsDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductsDetail.vue?vue&type=style&index=0&id=2a8914d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8914d5",
  null
  
)

export default component.exports